import * as React from "react";
import type { SVGProps } from "react";

interface ImportantProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Important = ({ cancelled = false, ...props }: ImportantProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 100"
    {...props}
  >
    <g>
    <image
      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADXElEQVR4nO2cv2obQRDGrzOot41fxnYaYYONcUCQYCxkUJEmxKBKSZUqTR7ApdyoSyXSBBdBBqvIAwTS6AEsgzglkc6y8oU5XSyQ9t+t7m5PzvxgGuk0O/sxd7c7uyvPYxiGYRjGEAAFAEUAdQANAB0AXQA9AEFkveizTnRNPfpNwXuKANgAcA6gHQlgSxD5IF8b3qoDYBtAC8AYyTOOfG97qwaAZwCukR3U1q6XdwBsAWjCHdT2lpdHAOwD6MM9FMO+lycA1ABMTHvwZxRg3PmG4cUlfr37gMHZG/ilKvyDk6mVquFn9B1dQ9fSb2JAsdTyIMxa9BrWi+IPcP/lK36//wj/qAx/70U8OyqHvyUf5MsQim3NlTjrAG60wgxHGDU/wT+uxBdFZseV0Cf5NoBiXHeROTdKYR4mCD5fYfDyVXLCzBn5pjaoLQORssskaG6rye0dfr5+m5ow80ZtUZsaGlk+kKU8fP+Rataosona1lDL4lU+kbV+f9WGf3iauTiPdngaxqBgktoQANNBYF8pjith5kwjUj+VwSQUI2RKbaeZI8gkze3WTFqcXWnO3t45eebojGLSPLiTm7tBMvGk12uWb6u4RrEphgDXSYmzI2uBxiCuRdAZxahg+VIJpjWXxewZjnJ5a4luNcWIu7WsOJuyYlc4fciBACZGsUoYL1WZxLS0uZg9/iDZuVXa9vxMNcE9X0agtsgjzaiddzqmUcwS2susPgQij2HJIgedjmMUs4TAarUkWmZZgApXVvUc13ZUVhXdijYC1UWeqLrnvLOWRrFLqCdW0hheXDrvqK1R7ImVQqJVzQWoTuy6o7ZGsUvo2AjUFXkKC+w56KyNUewSujYC9USewtWHHHTWykpVmUA9G4ECoUC0LOO6o7Z2cCITKGCB9pIXqMe3mFqgrkggfkjPBOqIBOLX/EyghkggHijOBKqLBOKpxkygokggnqzOBCpwuUP/qm+LsogLZk+t5HpcSa3kuslFe71ILWEW8bLPo0C011kILxxG8NKz2cZwIbx5IYK3v2gAb6DSA96CZyRSDQr+602c/+BtwBrAG8n1gI8iGInEh1lM4ONQBvCBOgP4SGa8jed8qNdwj3Xax8J3vFUH08ok/7GACfzXFAzDMAzjZcRfqtj+1a9zhPQAAAAASUVORK5CYII="
      width={100}
      height={100}
    />
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Important;
